var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "widM" }, [
      _c(
        "p",
        {
          staticClass: "fntH6 fntL bold padTS",
          staticStyle: { color: "#20893d" }
        },
        [_vm._v(_vm._s(_vm.activity.title))]
      )
    ]),
    _vm._v(" "),
    _c("hr", {
      style:
        _vm.seq === 0
          ? { "border-bottom": "1px solid #e3e3e3" }
          : { "border-top": "1px solid #e3e3e3" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "widM" }, [
      _c(
        "div",
        { staticClass: "clearfix" },
        [
          _vm._l(_vm.attendingList, function(attendant, idx) {
            return [
              _c("div", { key: "" + _vm.seq + idx }, [
                _c("div", { class: idx % 2 === 0 ? "floL" : "floR" }, [
                  _c(
                    "p",
                    {
                      staticClass: "fntH6 fntL bold padBSM",
                      staticStyle: { color: "#2c2c2c" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.getTextByType(attendant.type, attendant.type_seq)
                        ) + " 액티비티"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "amway-theme" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "radio-wrapper NCACroa_cont03_radio NCACroa_radioBtn"
                      },
                      _vm._l(_vm.activity.examples, function(example, se_code) {
                        return _c("SurveyExample", {
                          key: se_code + "_" + _vm.seq + idx,
                          staticClass: "amw-radio-wrap radio-label focus disBl",
                          attrs: {
                            example: example,
                            attendant: attendant,
                            "res-idx": _vm.getDataIdx(
                              attendant.type,
                              attendant.type_seq
                            ),
                            "prev-selected": _vm.isPrevSelectedExample(
                              se_code,
                              attendant
                            ),
                            unique: "" + _vm.seq + idx
                          }
                        })
                      }),
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              idx < _vm.attendingList.length - 1
                ? _c("hr", {
                    key: "hr" + _vm.seq + idx,
                    staticClass: "moOnly",
                    staticStyle: { "border-top": "1px solid #e3e3e3" }
                  })
                : _vm._e()
            ]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13b1f7e7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b1f7e7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/components/SurveyActivity.vue
// module id = null
// module chunks = 